import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex justify-center relative" };
import Menu from "primevue/menu";
import { computed, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UDropdownMenu',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        },
        margin: {
            type: String,
            default: "auto"
        }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const menu = ref();
        const buttonRef = ref();
        // Сохраняем последнее событие для повторного использования
        let lastEvent = null;
        const setButtonRef = (el) => {
            buttonRef.value = el;
        };
        const toggle = (event) => {
            if (event) {
                lastEvent = event;
                menu.value?.toggle(event);
            }
            else if (lastEvent && buttonRef.value) {
                // При отсутствии события используем сохраненное событие и кнопку
                const syntheticEvent = new Event("click");
                Object.defineProperty(syntheticEvent, "currentTarget", {
                    value: buttonRef.value,
                    configurable: true,
                    enumerable: true
                });
                // Клонируем координаты из lastEvent
                if (lastEvent instanceof MouseEvent) {
                    Object.defineProperties(syntheticEvent, {
                        clientX: { value: lastEvent.clientX, enumerable: true },
                        clientY: { value: lastEvent.clientY, enumerable: true },
                        pageX: { value: lastEvent.pageX, enumerable: true },
                        pageY: { value: lastEvent.pageY, enumerable: true }
                    });
                }
                menu.value?.toggle(syntheticEvent);
            }
        };
        const cssVars = computed(() => {
            return {
                "margin-top": props.margin
            };
        });
        __expose({ toggle });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "button", {
                    toggle: toggle,
                    setButtonRef: setButtonRef
                }),
                _createVNode(_unref(Menu), {
                    ref_key: "menu",
                    ref: menu,
                    class: "menu",
                    style: _normalizeStyle(cssVars.value),
                    model: __props.items,
                    popup: true
                }, _createSlots({ _: 2 }, [
                    (_ctx.$slots['item'])
                        ? {
                            name: "item",
                            fn: _withCtx(({ item, props }) => [
                                _renderSlot(_ctx.$slots, "item", {
                                    item: item,
                                    props: props
                                })
                            ]),
                            key: "0"
                        }
                        : undefined
                ]), 1032, ["style", "model"])
            ]));
        };
    }
});
